// extracted by mini-css-extract-plugin
export default {"gridContainer":"FiveElementScore_gridContainer__jLKkd","grid-item":"FiveElementScore_grid-item__LWtyP"};